export enum VivaISV {
  FORTYTWO = 0.42,
  THIRTYTWO = 0.32,
  TWENYTWO = 0.22,
  TWELVE = 0.12,
}

export enum VivaISVTurnover {
  DEFAULT = 'DEFAULT',
  SIXTY = 'SIXTY',
  HUNDRED = 'HUNDRED',
  THREE_HUNDRED = 'THREE_HUNDRED',
}

export const VivaISVTurnoverMap = {
  [VivaISVTurnover.DEFAULT]: VivaISV.FORTYTWO,
  [VivaISVTurnover.SIXTY]: VivaISV.THIRTYTWO,
  [VivaISVTurnover.HUNDRED]: VivaISV.TWENYTWO,
  [VivaISVTurnover.THREE_HUNDRED]: VivaISV.TWELVE,
};

export const vivaISVMap = {
  [VivaISV.FORTYTWO]: VivaISVTurnover.DEFAULT,
  [VivaISV.THIRTYTWO]: VivaISVTurnover.SIXTY,
  [VivaISV.TWENYTWO]: VivaISVTurnover.HUNDRED,
  [VivaISV.TWELVE]: VivaISVTurnover.THREE_HUNDRED,
};
